var map = {
	"./home-desktop.png": 1297,
	"./home-mobile.png": 9438,
	"./patient-desktop.png": 7853,
	"./patient-mobile.png": 9217,
	"./reports-desktop.png": 2466,
	"./reports-mobile.png": 4081,
	"./schedule-desktop.png": 489,
	"./schedule-mobile.png": 1627,
	"./shield-desktop.png": 7766,
	"./shield-mobile.png": 8186,
	"./statistics-desktop.png": 4801,
	"./statistics-mobile.png": 7623
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2478;